<div class="tab-inner-content">
  <h2>Customer Balance Summary</h2>
  <h5>
    From {{ startDate | date : "MM/d/YYYY" }} to
    {{ endDate | date : "MM/d/YYYY" }}
  </h5>
  <table>
    <thead>
      <tr>
        <th>Customer Name</th>
        <th>Total Amount</th>
        <th>Pending Amount</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of customerBalanceSummaryReport">
        <td>{{ item.name }}</td>
        <td>{{ item.totalAmount | number : "1.2-2" }}</td>
        <td>{{ item.pendingAmount | number : "1.2-2" }}</td>
      </tr>
      <tr *ngIf="customerBalanceSummaryReport?.length === 0">
        <td colspan="3" class="no-data">
          No data available
        </td>
      </tr>
    </tbody>
  </table>
</div>
